



























































































































import Vue from 'vue';
import GwtpBox from '../components/GwtpBox.vue';
import { BACKEND_URL } from "../constants";

const ITEMS_URL = BACKEND_URL + "/list/";

export default Vue.extend({

    components: {
        GwtpBox,
    },

    data() {
        return {
            storylines: [] as any[],
        };
    },

    mounted() {
        this.loadData();
    },

    methods: {
        loadData() {
            Vue.axios.get(ITEMS_URL + "?types=storyline&limit=100").then((response: { data: any }) => {
                const stories: any[] = response.data.items.reverse();
                this.storylines = [];
                let currentRun = null as any;
                for (const story of stories) {
                    if (story.name[0] === '!') {
                        // "Major story" (start of a new run of comics)
                        story.name = story.name.substr(1);
                        story.storylines = [];
                        story.storylinesVisible = false;
                        this.storylines.push(story);
                        currentRun = story;
                    } else {
                        // Regular storyline in the current run
                        currentRun.storylines.push(story);
                    }
                }
            });
        },
    }

});
